//@ts-ignore
//@ts-nocheck
import React, { useState, useEffect } from "react";
import {
  Popconfirm,
  Table,
  Button,
  Input,
  Form,
  Modal,
  Checkbox,
  Row,
  Col,
  Tooltip,
  Divider,
  Radio,
  Upload,
  message,
} from "antd"; // NOSONAR : ignore
import { PlusOutlined, EditOutlined, HistoryOutlined } from "@ant-design/icons"; // NOSONAR : ignore
import IDynamicTable from "./IDynamicTable"; // NOSONAR : ignore
import {
  BsColumns,
  BsPinAngle,
  BsPinAngleFill,
  BsPinFill,
  BsThreeDotsVertical,
} from "react-icons/bs"; // NOSONAR : ignore
import * as AntIcons from "@ant-design/icons";
import TableFilters from "./TableFilters";
import { FaFilter } from "react-icons/fa6"; // NOSONAR : ignore
import Panel from "antd/es/splitter/Panel"; // NOSONAR : ignore
import "../../App.css";
import { useNavigate } from "react-router-dom";
import type { TableColumnsType, TableProps } from "antd"; // NOSONAR : ignore
import Item from "antd/es/list/Item";
import DynamicModal from "../DynamicModal";
import { usePermission } from "../../Helpers/PermissionContext/PermissionContext";
import { Link } from "react-router-dom";
import { useActionHandler } from "../../Components/ActionHandlerContext";

const FormTable = ({
  columns = [],
  isAddRowTable = false,
  name,
  dataSource = [],
  onChange,
  keyIdentity = null,
  filters,
  form,
  isReset = false,
  setIsReset = null,
  //handleButtonClick = () => { },
  field = {},
  fields = [],
  section = {},
  tableCheckbox,
  showSearchInput,
  handleSearch,
  searchValue,
  searchErrorMessage,
  pageButtons,
  handlePageActionClick,
  loadingState,
  ...rest
}: any) => {
  const [data, setData] = useState([]);

  const [editingKey, setEditingKey] = useState<string>("");
  const [tempData, setTempData] = useState({}); // NOSONAR : ignore

  const [updatedColumns, setUpdatedColumns] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [gridColumns, setGridColumns] = useState<any[]>([]); // NOSONAR : ignore
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false);
  const [fileList, setFileList] = useState([]);
  const { HasPermission } = usePermission();
  const { rowActionHandler } = useActionHandler();

  useEffect(() => {
    if (columns && columns.length > 0) {
      setUpdatedColumns([...columns]);
      setVisibleColumns(
        [...columns].map((data) => {
          return data.dataIndex;
        }),
      );
    }
  }, [columns]);

  const handleUpload = async () => {
    const formData = new FormData();

    // Append the selected file(s) to FormData
    fileList.forEach((file: any) => {
      formData.append("file", file); // "file" is the key to use on the backend
    });
    // Close modal and clear file list after uploading
    setModalVisible(false);
    setFileList([]);
  };

  const handleCancelUpload = () => {
    setModalVisible(false);
    setFileList([]); // clear files on cancel
  };

  const uploadProps = {
    beforeUpload: (file: any) => {
      setFileList((prev) => [...prev, file]);
      return false;
    },
    onRemove: (file: any) => {
      setFileList((prev) => prev.filter((f) => f.uid !== file.uid));
    },
    fileList,
    multiple: true,
  };

  useEffect(() => {
    if (columns && columns.length > 0) {
      setData([...dataSource]);
    }
  }, [dataSource]);

  const [isVisibleColumnsModalVisible, setIsVisibleColumnsModalVisible] =
    useState(false);
  const [visibleColumnsModalSearchText, setVisibleColumnsModalSearchText] =
    useState<string>(""); // State for search input

  useEffect(() => {
    // Whenever the data state changes, update the 'addedRows' field in the form
    form?.setFieldValue(name, data);
    const allFields = form?.getFieldsValue(); // NOSONAR : ignore
  }, [data]);

  const isEditing = (record: any) => record.key === editingKey;

  const edit = (record: any) => {
    // NOSONAR : ignore
    form.setFieldsValue({ ...record });
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey("");
  };

  // Added ne action column
  // Define the action column
  const actionColumn = {
    // NOSONAR : ignore
    title: "Action",
    dataIndex: "action",
    key: "action",
    fixed: "right",
    width: 100,
    render: (_, record) => (
      <Tooltip>
        <Button
          type="link"
          icon={<EditOutlined />}
          onClick={() => handleEdit(record)}
          title="Edit"
        />
        <Button
          type="link"
          icon={<HistoryOutlined />}
          onClick={() => handleEdit(record)}
          title="History"
        />
      </Tooltip>
    ),
  };

  const handleEdit = (record) => {
    setEditingKey(record.Key); // Set row as editable
    navigate("/DynamicFormComponent", {
      state: {
        id: record.interfaceId,
        actionType: "Edit",
        RId: record.Key,
        Mode: "Edit",
      },
    });
  };
  const mergedColumns = updatedColumns
    .map((col: any) => {
      return {
        ...col,
        render: col.isClickable
          ? (text: any, record: TableRecord) => (
              <span
                style={{
                  cursor: "pointer",
                  color: "#000000",
                  textDecoration: "underline",
                }}
                onClick={async () => {
                  if (col.clickHandler && col.clickHandler !== "") {
                    const handler = rowActionHandler[col.clickHandler];

                    if (handler) {
                      await handler(form, record, null);
                    }
                  }
                }}
              >
                {text}
              </span>
            )
          : col.render,
        onCell: (record: any, index: number) => {
          // NOSONAR : ignore
          let onCellObj = {
            record,
            inputType: col.type,
            dataIndex: col.dataIndex,
            title: col.title,
            editing: col.isFieldEditable ?? isEditing(record),
          };
          if (col.rowSpan) {
            const rowSpanStart =
              col.rowSpanStart && col.rowSpanStart > 0
                ? col.rowSpanStart - 1
                : 0;

            const rowSpanEnd =
              col.rowSpanEnd && dataSource.length >= col.rowSpanEnd
                ? col.rowSpanEnd
                : dataSource.length;

            if (index === rowSpanStart) {
              onCellObj = {
                ...onCellObj,
                rowSpan: rowSpanEnd - rowSpanStart,
              }; // Apply rowspan to the first row
            } else if (index > rowSpanStart && index <= rowSpanEnd) {
              onCellObj = { ...onCellObj, rowSpan: 0 };
            }
          }
          if (col.colSpan) {
            const colSpanStart =
              col.colSpanStart && col.colSpanStart > 0
                ? col.colSpanStart - 1
                : 0;
            const SpanEnd =
              col.colSpanEnd && dataSource.length >= col.colSpanEnd
                ? col.colSpanEnd
                : dataSource.length;

            if (index === colSpanStart) {
              onCellObj = {
                ...onCellObj,
                colSpan: SpanEnd - colSpanStart,
              }; // Apply rowspan to the first row
            } else if (index > colSpanStart && index <= SpanEnd) {
              onCellObj = { ...onCellObj, colSpan: 0 };
            }
          }
          return onCellObj;
        },
      };
    })
    .filter((column: any) => visibleColumns.includes(column.dataIndex));

  const newupdatedColumns = [...mergedColumns];

  const EditableCell: React.FC<any> = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    children,
    ...restProps
  }) => {
    // NOSONAR : ignore
    const [form1] = Form.useForm();
    const inputNode = inputType ? (
      inputType === "number" ? ( // NOSONAR : ignore
        <InputNumber />
      ) : (
        <Input />
      )
    ) : (
      <Input />
    );

    const inputRef = React.useRef<any>(null); // Local ref for the input element
    return (
      <td {...restProps}>
        <Form form={form1} component={false}>
          {editing ? (
            <Form.Item
              name={dataIndex}
              style={{ margin: 0 }}
              rules={[
                {
                  required: true,
                  message: `Please Input ${title}!`,
                },
                {
                  validator: async (_: any, value: any) => {
                    if (dataIndex === "age" && isNaN(value)) {
                      return Promise.reject(
                        new Error("Age should be a number"),
                      );
                    }
                    if (dataIndex === "age" && value <= 15) {
                      return Promise.reject(new Error("Age should be > 15"));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              {React.cloneElement(inputNode, {
                ref: inputRef,
                defaultValue: record[dataIndex],
                onBlur: (e: any) => {
                  save(record.key, e.target.value, dataIndex, form1);
                },

                onMouseEnter: () => {
                  // Optionally, highlight the input field when hovered
                  inputRef.current.focus();
                },
              })}
            </Form.Item>
          ) : (
            children
          )}
        </Form>
      </td>
    );
  };
  const handleTableChange = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: any,
  ) => {
    const newColumns = updatedColumns?.map((column: any) => {
      if (!column || typeof column !== "object") return column; // skip if not a valid object

      const isPinned = filters[column.key]?.includes("Pin");

      return {
        ...column,
        fixed: isPinned ? true : undefined,
        filterIcon: (
          filtered: any, // NOSONAR : ignore
        ) => (
          <div
            style={{ display: "flex", justifyContent: "space-between", gap: 3 }}
          >
            {isPinned && (
              <div style={{ position: "relative" }}>
                <BsPinAngleFill
                  color="blue"
                  style={{
                    position: "absolute",
                    top: 2,
                    right: -4,
                    fontSize: "10px",
                  }}
                />
              </div>
            )}
            <BsThreeDotsVertical
              style={{
                color: filtered ? "blue" : "black",
                fontSize: "18px",
              }}
            />
          </div>
        ),
      };
    });

    setUpdatedColumns(newColumns);
    onChange?.(pagination, filters, sorter, extra);
  };

  // Handle opening the column management modal
  const handleManageColumns = () => {
    // NOSONAR : ignore
    setIsVisibleColumnsModalVisible(true);
  };

  // Handle closing the modal
  const handleCancel = () => {
    setVisibleColumnsModalSearchText("");
    setIsVisibleColumnsModalVisible(false);
  };

  // Handle column visibility toggle
  const handleColumnToggle = (columnKey: string, checked: boolean) => {
    setVisibleColumns((prevVisibleColumns) =>
      checked
        ? [...prevVisibleColumns, columnKey]
        : prevVisibleColumns.filter((key) => key !== columnKey),
    );
  };

  // Handle search input change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setVisibleColumnsModalSearchText(e.target.value);
  };

  // Filter columns based on search text using regex
  const filteredColumns = updatedColumns.filter((column: any) => {
    try {
      // Create a case-insensitive regex from the search text
      const regex = new RegExp(visibleColumnsModalSearchText, "i"); // 'i' for case-insensitive matching

      // Use regex test to check if the searchText matches the column title
      return regex.test(column.key);
    } catch (e) {
      // If the searchText is not a valid regex, fall back to default behavior (e.g., case-insensitive match)
      console.error("Invalid Regex", e, column.key);
      return column.key;
    }
  });

  // Render the column visibility management modal
  const renderColumnVisibilityModal = () => (
    <Modal
      title="Manage Columns"
      open={isVisibleColumnsModalVisible}
      onCancel={handleCancel}
      footer={null}
      width={300} // Adjust the width of the modal
      style={{
        maxHeight: "400px", // Medium height for the modal
        // Enable scrolling for content inside the modal
      }}
    >
      <div>
        {/* Search input field */}
        <Input
          placeholder="Search Columns"
          value={visibleColumnsModalSearchText}
          onChange={handleSearchChange}
          style={{ marginBottom: 15 }}
        />

        {/* Scrollable list of checkboxes */}
        <div style={{ maxHeight: 300, overflowY: "auto" }}>
          {filteredColumns.map((column: any) => (
            <div key={column.key} style={{ marginBottom: 10 }}>
              <Checkbox
                checked={visibleColumns.includes(column.key)}
                onChange={(e) =>
                  handleColumnToggle(column.key, e.target.checked)
                }
              >
                {column.title}
              </Checkbox>
            </div>
          ))}
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={handleCancel}>Close</Button>
        </div>
      </div>
    </Modal>
  );

  // For the row selection.
  const rowSelection: TableProps<DataType>["rowSelection"] = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {},
    getCheckboxProps: (record: DataType) => ({
      disabled: record.name === "Disabled User", // Column configuration not to be checked
      name: record.name,
    }),
  };
  const getIcon = (iconName) => {
    const Icon = AntIcons[iconName];
    if (Icon) {
      return <Icon />;
    }
    // If icon name is not found, return null or a default icon (optional)
    return null;
  };
  return (
    <Form form={form} component={false} style={{ width: "100%" }}>
      {renderColumnVisibilityModal()}
      {isAddRowTable ? (
        <>
          <Row gutter={16} className="filterRow">
            <Col
              lg={24}
              xs={24}
              sm={24}
              md={12}
              className="filterGrid d-md-flex d-sm-block justify-content-end gap-2"
            >
              <div>
                <div className="buttons d-flex gap-2 justify-content-end">
                  {pageButtons?.map((button: any, index: number) => {
                    return (
                      (HasPermission(button.visibility?.edit) ||
                        HasPermission(button.visibility?.readonly)) && (
                        <Button
                          key={crypto.randomUUID()}
                          onClick={() => handlePageActionClick(button)}
                          loading={loadingState[button.label]}
                          disabled={
                            (HasPermission(button.visibility?.edit)
                              ? false
                              : HasPermission(button.visibility?.readonly) // NOSONAR : ignore
                                ? true
                                : false) || loadingState[button.label]
                          }
                          className={button.className}
                        >
                          {button.icon ? getIcon(button.icon) : button.label}
                        </Button>
                      )
                    );
                  })}
                  {/* <Button
                  type="primary"
                  key={"BulkUpload"}
                  icon={getIcon("UploadOutlined")}
                  title="Bulk Upload"
                  onClick={() => setModalVisible(true)}
                ></Button> */}
                </div>
              </div>
              <div>
                {showSearchInput && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                    className="search_input"
                  >
                    <Input
                      placeholder="Search..."
                      autoComplete="off"
                      value={searchValue}
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                    {searchErrorMessage && (
                      <div style={{ color: "red", marginTop: "5px" }}>
                        {searchErrorMessage}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <DynamicModal
            title="Bulk Upload"
            open={modalVisible}
            onOk={handleUpload}
            onCancel={handleCancelUpload}
            okText="Upload"
          >
            <Upload {...uploadProps}>
              <Button icon={getIcon("UploadOutlined")}>Select Files</Button>
            </Upload>
            <p style={{ marginTop: 10, color: "#888" }}>
              Accepts .csv, .xlsx, or .xls files
            </p>
          </DynamicModal>
        </>
      ) : null}
      <Form.Item name={name} hidden>
        <Input />
      </Form.Item>
      <TableFilters
        config={filters}
        //handleButtonClick={handleButtonClick}
        isReset={true}
      />
      <Table
        {...(tableCheckbox && {
          rowSelection: {
            ...(section?.rowSelection ?? { type: "checkbox" }),
            ...rowSelection,
          },
        })}
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        scroll={{ x: "max-content" }}
        bordered
        dataSource={data}
        columns={newupdatedColumns}
        rowClassName="editable-row"
        style={{ width: "100%" }}
        onChange={handleTableChange}
        pagination={{
          onChange: cancel,
          position: [isAddRowTable ? "none" : "bottomRight"],
        }}
        {...rest}
      />
    </Form>
  );
};

export default FormTable;
